import React from 'react';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';
import AccessRestricted from "../../../assets/images/AccessRest.png"
import { useAppSelector } from '../../../state/state';
import { selectActiveRole } from '../../../state/UserStatesV2/userSliceV2';

interface AccessControlProps {
    children: React.ReactNode;
    pageName: string;
    restrictObserverOnly?: boolean;
}

const AccessControl: React.FC<AccessControlProps> = ({
    children,
    pageName,
    restrictObserverOnly = false
}) => {

    const activeRole = useAppSelector(selectActiveRole);
    const role = activeRole?.role;
    let hasAccess = false;
    // Show loading state if activeRole is undefined (still loading)
    if (activeRole === undefined) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '80vh',
                    width: '100%',
                }}
            >
                <CircularProgress />
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Loading...
                </Typography>
            </Box>
        );
    }

    if (!role) {
        hasAccess = true;
    } else if (role === "Administrator") {
        hasAccess = true;
    } else {
        hasAccess = activeRole[pageName] || false;
    }

    if (restrictObserverOnly) {
        if (role === "Observer") {
            hasAccess = false;
        } else {
            hasAccess = true;
        }
    }


    if (!hasAccess) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '80vh',
                    width: '100%',
                    position: 'relative',
                    backgroundColor: 'background.default',
                }}
            >

                <Box
                    component="img"
                    src={AccessRestricted}
                    alt="Restricted Access"
                    sx={{
                        width: { xs: 120, sm: 280 },
                        height: 'auto',
                        zIndex: 2,
                        mt: 8,
                        mb: 2,
                    }}
                />
                {/* Text and button */}
                <Paper
                    elevation={0}
                    sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 1,
                        background: 'transparent',
                        boxShadow: 'none',
                        zIndex: 3,
                    }}
                >
                    <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }} gutterBottom>
                        Restricted Access
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        You lack permissions to access this page - Please contact your administrator
                    </Typography>

                </Paper>
            </Box>
        );
    }

    return <>{children}</>;
};

export default AccessControl; 